<ion-header mode="ios">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="dismiss()">
        <ion-icon slot="icon-only" name="chevron-back"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>Import summary</ion-title>
    <ion-buttons slot="end">
      <ion-button class="btn-reports" color="dark" fill="clear" aria-label="reports" (click)="downloadSummaryReport()">
        <ion-icon slot="icon-only" src="assets/icons/xlsx-file.svg"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <ion-grid class="summary">
    <ion-row>
      <ion-col size="6" size-md="3">
        <div class="summary-value">{{ response().relevantAddresses }}</div>
        <div class="summary-label">Relevant</div>
      </ion-col>
      <ion-col size="6" size-md="3">
        <div class="summary-value">{{ response().needManualReview }}</div>
        <div class="summary-label">Manual review</div>
      </ion-col>
      <ion-col size="6" size-md="3">
        <div class="summary-value">{{ response().corrected }}</div>
        <div class="summary-label">Corrected</div>
      </ion-col>
      <ion-col size="6" size-md="3">
        <div class="summary-value">{{ response().moved }}</div>
        <div class="summary-label">Moved</div>
      </ion-col>
    </ion-row>
  </ion-grid>

  @if (response().errors.length) {
    <ion-list [inset]="true">
      <ion-item lines="none" color="danger">
        <ion-icon slot="start" name="alert-circle"></ion-icon>
        <ion-label>{{ response().errors.length }} row(s) could not be parsed</ion-label>
      </ion-item>
      @for (err of response().errors; track err.row) {
        <ion-item>
          <ion-label>
            <h3>
              Row {{ err.row }}
              @if (err.customerId) {
                &mdash; Customer {{ err.customerId }}
              }
            </h3>
            <p>{{ err.message }}</p>
          </ion-label>
        </ion-item>
      }
    </ion-list>
  }

  <ion-segment [value]="filter()" (ionChange)="setFilter($event.detail.value)" mode="ios">
    <ion-segment-button value="all">
      <ion-label>All ({{ response().changes.length }})</ion-label>
    </ion-segment-button>
    <ion-segment-button [value]="Action.MANUAL_REVIEW">
      <ion-label>{{ actionLabel(Action.MANUAL_REVIEW) }} ({{ response().needManualReview }})</ion-label>
    </ion-segment-button>
    <ion-segment-button [value]="Action.CORRECTED">
      <ion-label>{{ actionLabel(Action.CORRECTED) }} ({{ response().corrected }})</ion-label>
    </ion-segment-button>
    <ion-segment-button [value]="Action.MOVED">
      <ion-label>{{ actionLabel(Action.MOVED) }} ({{ response().moved }})</ion-label>
    </ion-segment-button>
  </ion-segment>

  <ion-accordion-group class="changes">
    @for (change of listChanges(); track change.contactId + change.kind) {
      <ion-accordion>
        <ion-item slot="header" color="light">
          <ion-label>
            <h2>{{ change.contactName || change.organization }}</h2>
          </ion-label>
          <ion-badge slot="end" [color]="actionColor(change.action)">
            {{ actionLabel(change.action) }}
          </ion-badge>
        </ion-item>

        <div class="accordion-content" slot="content">
          <ion-list [inset]="true" class="inset-list">
            <ion-item>
              <ion-label>
                <p>{{ change.kind }} address &mdash; QSTAT {{ change.qstat }}</p>
                <p>{{ change.qstatDescription }}</p>
              </ion-label>
              <ion-button slot="end" size="large" fill="clear" (click)="openContactDetailsPage(change.contactId)">
                <ion-icon slot="icon-only" name="person-circle-outline"></ion-icon>
              </ion-button>
            </ion-item>

            @if (change.action === Action.MANUAL_REVIEW) {
              <ion-item>
                <ion-label>
                  <h3>Address</h3>
                  <p>{{ addressLine(change.oldAddress) }}</p>
                </ion-label>
              </ion-item>
            } @else {
              <ion-item>
                <ion-row style="width: 100%">
                  <ion-col size="6" class="ion-text-center">
                    <ion-label>
                      <h3>Previous address</h3>
                      <p>{{addressLine(change.oldAddress)}}</p>
                    </ion-label>
                  </ion-col>
                  <ion-col size="6" class="ion-text-center">
                    <ion-label>
                      <h3>New address</h3>
                      <p>{{addressLine(change.newAddress)}}</p>
                    </ion-label>
                  </ion-col>
                </ion-row>
              </ion-item>

              <ion-item>
                <ion-grid class="compare-addresses">
                  <ion-row>
                    <ion-col size="6" class="border-right ion-text-end">{{change.oldAddress?.STREET}}</ion-col>
                    <ion-col size="6" class="border-left">{{change.newAddress.STREET}}</ion-col>
                  </ion-row>
                  <ion-row>
                    <ion-col size="6" class="border-right ion-text-end">{{change.oldAddress?.POSTAL_CODE}}</ion-col>
                    <ion-col size="6" class="border-left">{{change.newAddress.POSTAL_CODE}}</ion-col>
                  </ion-row>
                  <ion-row>
                    <ion-col size="6" class="border-right ion-text-end">{{change.oldAddress?.CITY}}</ion-col>
                    <ion-col size="6" class="border-left">{{change.newAddress.CITY}}</ion-col>
                  </ion-row>
                </ion-grid>
              </ion-item>
            }

            @if (change.changedFields.length) {
              <ion-item>
                <ion-label class="ion-text-center">
                  @for (field of change.changedFields; track field) {
                    <ion-badge color="tertiary" class="changed-field">{{ field }}</ion-badge>
                  }
                </ion-label>
              </ion-item>
            }
          </ion-list>
        </div>
      </ion-accordion>
    }

    @if (!filteredChanges().length) {
      <ion-item lines="none">
        <ion-label class="ion-text-center">No changes in this category.</ion-label>
      </ion-item>
    } @else if (!isLastBunchChanges()) {
      <ion-infinite-scroll (ionInfinite)="doInfinite($event)">
        <ion-infinite-scroll-content loadingSpinner="crescent"></ion-infinite-scroll-content>
      </ion-infinite-scroll>
    }
  </ion-accordion-group>
</ion-content>
